import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------
import {
  forEach as _forEach
} from 'lodash-es';
const baseClass = 'parallax-container--footer';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class Parallax {
  constructor(el) {
    this.el = el;
    this.intersectingElements = new Set();

    this.observer();
  }

  observer() {
    const observerElement = $(`.${baseClass}`);

    const contentObserver = new IntersectionObserver(elements => {
      for (const element of elements) {
        if (element.isIntersecting) {
          this.intersectingElements.add(element.target);
        } else {
          this.intersectingElements.delete(element.target);
        }
      }

      if (this.intersectingElements.size > 0) {
        $(`.${baseClass}`).addClass('is-visible');
      } else {
        $(`.${baseClass}`).removeClass('is-visible');
      }
    }, {rootMargin: "30% 0% 30% 0%"});

    _forEach(observerElement, (item) => {
      contentObserver.observe(item);
    });
  }


  throttle(fn, wait) {
    let time = Date.now();
    return function() {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    }
  };

  eparallax(element) {


  };
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new Parallax(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
